import { render, staticRenderFns } from "./AddFoodSpec.vue?vue&type=template&id=359e278c&"
import script from "./AddFoodSpec.vue?vue&type=script&lang=js&"
export * from "./AddFoodSpec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports